import { z } from 'zod'

const IdTokenPayloadSchema = z.object({ sub: z.string().min(1) })

/**
 * IdToken（JWT）の payload から sub（Cognito のユーザー ID）を取り出す（#3760）。
 *
 * 署名は検証しない。「メモリの会員と Cookie の会員が同じか」を比べるためだけに使い、
 * 認可の判断には使わない（認可は API 側がトークンを検証する）。
 * 形が想定と違うときは null を返し、呼び出し側は「判定できない → 何もしない」に倒す。
 */
export const readIdTokenSubject = (idToken: string): string | null => {
  const payload = idToken.split('.')[1]
  if (!payload) return null
  try {
    // base64url → base64。atob は padding なしでも受け付ける。sub は UUID（ASCII）なので UTF-8 として読み直さない
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const parsed = IdTokenPayloadSchema.safeParse(JSON.parse(json))
    return parsed.success ? parsed.data.sub : null
  } catch {
    return null
  }
}
